import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { SurveyForm } from '../types/index'
import { saveAnswerAPI } from '../api/surveyAPI';
import { useTranslation } from "react-i18next";

export default function SurveyFormCheckbox({ surveyItem, idPerson, reloadSurvey }: SurveyForm) {

    const [checked, setChecked] = useState < number[]>([])
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const answerChecked = surveyItem.answers.filter(answer => checked.includes(answer.id));
        const value = answerChecked
            .map(answer => answer.description) 
            .join('. ');
        const body = {
            IdSurvey: surveyItem.idSurvey,
            IdPerson: idPerson,
            IdQuestion: surveyItem.question.id,
            IdAnswer: checked[0],
            Value: value,
            Order: surveyItem.question.order,
        }

        try {
            const result = saveAnswerAPI(body);
        } catch (error) {
            console.error(error);

        } finally {
            const order = surveyItem.question.order + 1;
            if (order > surveyItem.numQuestions) {
                navigate("/end-survey/" + surveyItem.idSurvey + "/" + order);
            } else {
                navigate("/survey/" + surveyItem.idSurvey + "/" + order);
                reloadSurvey(Number(order));
            } 
        }
    };

    const handlback = () => {
        if (surveyItem.question.order === 1) {
            navigate("/pending-surveys");
        } else {
            const order = surveyItem.question.order - 1;
            navigate("/survey/" + surveyItem.idSurvey + "/" + order);
            reloadSurvey(Number(order));
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (surveyItem?.answerValue?.idAnswer !== undefined) {
                    setChecked([surveyItem.answerValue.idAnswer]);
                    //setValue(surveyItem.answerValue.value);
                }

            } catch (error) {
                console.error(error);

            } finally {
                console.log("loaded");
            }
        }

        fetchData()
    }, [surveyItem])

    const handleCheck = (value:number) => {
        setChecked((prevChecked) =>
            prevChecked.includes(value)
                ? prevChecked.filter((checked) => checked !== value)
                : [...prevChecked, value],
        );
    }

    return (
        <>
            
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Form.Group>
                        <Form.Label className="d-flex question" > {surveyItem !== null ? surveyItem.question.order + ".- " + surveyItem.question.description : ""} </Form.Label>
                                            
                    </Form.Group>
                                        
                </Row>

                <Row>
                    {surveyItem.answers.map((answer) => (
                        <Form.Check 
                            type="checkbox"
                            value={answer.id}
                            label={answer.description}
                            checked={checked.includes(answer.id)}
                            disabled={surveyItem.dataAnswer !== null}
                            onChange={(e) => handleCheck(Number(e.target.value))}
                        />
                    ))}
                </Row>
                <Row className="btns-margin">
                    <Col xs={3} md={3}>
                        <Button variant="light" className="btn btn-secondary w-100" onClick={handlback}>
                            <img
                                src="/back.svg"
                                alt="back"
                                style={{ width: '20px' }}
                            />
                        </Button>
                    </Col>
                    <Col xs={9} md={9}>
                        <Button variant="success" className="w-100" type="submit">
                            {t("surveyPendingQuestionButtonNext")}
                        </Button>
                    </Col>
                </Row>
            </Form>
                           
        </>
               
    );
}